import { useTranslation } from 'react-i18next'
import { RankmiTable } from '@rankmi/rankmi-table'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'antd'
import { ILearningProgram } from 'interfaces/roles'
import { useRolesAndPermissions } from '../../../../context/RolesAndPermissionsContext'
import { RankmiTableWrapper } from './styled'
import Options from './options'
import Courses from './courses'

interface ILearningProgramsProps {
  addLearningProgram: () => void
  disabled?: boolean
}

const LearningPrograms = ({
  addLearningProgram,
  disabled = false,
}: ILearningProgramsProps) => {
  const { t } = useTranslation()
  const { roleDetail: data } = useRolesAndPermissions()
  const prefix =
    'configuration.rolesAndPermissions.form.sections.accessToLearningPrograms.learningPrograms'

  const columns = [
    {
      title: `${t(`${prefix}.table.headers.name`)}`,
      key: 'name',
      render: (name: string) => name,
    },
    {
      title: `${t(`${prefix}.table.headers.courses.title`)}`,
      width: 171,
      render: (learningProgram: ILearningProgram) => (
        <Courses learningProgram={learningProgram} />
      ),
    },
    {
      width: 66,
      align: 'center',
      render: (learningProgram: ILearningProgram) => (
        <Options learningProgram={learningProgram} disabled={disabled} />
      ),
    },
  ]

  return (
    <RankmiTableWrapper>
      <RankmiTable columnHeaders={columns} data={data.learningPrograms} />
      <Button onClick={addLearningProgram} disabled={disabled}>
        <FontAwesomeIcon icon={faPlus} />
        {t(`${prefix}.add`)}
      </Button>
    </RankmiTableWrapper>
  )
}

export default LearningPrograms
